/**
 *
 * @component 个人中心/项目管理/协作项目详情/施工进度计划/新增计划弹框
 *
 **/

import { memo } from 'react';
import {
    Form,
    DatePicker,
    Radio,
    Select,
    Checkbox,
    Input,
    Space,
    Button,
    Tooltip,
    Upload,
    message,
    Image,
    AutoComplete,
} from 'antd';
import BaseModal from '&/components/BaseModal';
import PlanTreeModal from './PlanTreeModal';
import { createUUID } from '&/utils/common.js';
import { DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getConfirmation } from '@/utils/$axios';
import {
    addPlan,
    uploadFile,
    queryTimes,
    getTemplateTagList,
} from '@/api/personCenter/projectSpace1.4';
import moment from 'moment';

import './NewPlan.scss';

function NewPlan(props) {
    const {
        visible,
        setVisible,
        onSuccess,
        pID,
        members = [],
        isNeed = false,
        targetPlanId,
    } = props;
    useEffect(() => {}, []);
    useEffect(() => {}, [members]);
    useEffect(() => {
        if (visible) {
            queryTagList();
            setSelectDrawing([]);
        }
    }, [visible]);
    const closeModal = () => {
        setVisible(false);
        cleanData();
    };

    const previewPDF = src => {
        // 协议统一
        const path = src.replace(/^https?:/i, window.location.protocol);
        window.open(window.location.origin + `/preview-pdf?path=${path}`);
    };
    const [isPreview, setIsPreview] = useState(false);
    const [currentPreview, setCurrentPreview] = useState();

    const ACCEPT_LIST = [
        'image/png',
        'image/jpg',
        'image/jpeg',
        'image/bmp',
        'application/pdf',
    ];

    const [accept, setaccept] = useState(ACCEPT_LIST.toString(','));
    const ATTRS = {
        multiple: true,
        // maxCount: 1,
        // showUploadList: false,
        accept,
        data: ({ name }) => ({
            fileName: name,
            dap: 2, // dap
        }),
        onPreview(file) {
            if (file.response?.fileType === 3) {
                previewPDF(file.response.fileLink);
                return;
            }
            if (file.response?.fileType === 1) {
                setCurrentPreview(file.response.fileLink);
                setIsPreview(true);
            }
        },
        customRequest: async param => {
            const { file, onSuccess, onError, data, onProgress } = param;
            const uuid = createUUID();
            const SLIECE_SIZE = 8 * 1024 ** 2;
            const len = Math.ceil(file.size / SLIECE_SIZE);
            const paramList = [];
            let sliceTotle = [];
            let loaded = [];
            let type = file.type.includes('image')
                ? 1
                : file.type.includes('pdf')
                ? 3
                : 2;
            for (let i = 0; i < len; i++) {
                const blob =
                    i === len - 1
                        ? file.slice(i * SLIECE_SIZE, file.size)
                        : file.slice(i * SLIECE_SIZE, (i + 1) * SLIECE_SIZE);

                paramList.push({
                    ...data,
                    type,
                    file: blob,
                    blobNum: i + 1,
                    totalBlobNum: len,
                    uuid,
                });
                sliceTotle.push(100 / len);
                loaded.push(0);
            }

            // let item =
            const requestList = paramList.map((e, idx) => {
                const formData = new FormData();
                Object.entries(e).forEach(([k, v]) => {
                    formData.append(k, v);
                });
                return uploadFile(formData, evt => {
                    loaded[idx] = sliceTotle[idx] * (evt.loaded / evt.total);
                    onProgress({
                        percent: loaded.reduce((prev, next) => prev + next, 0),
                    });
                });
            });

            axios
                .all(requestList)
                .then(arr => {
                    const LATEST = arr.find(e => e.code === 0);
                    onSuccess({ ...LATEST.data, fileType: type });
                })
                .catch(error => {
                    getConfirmation();
                    onError(error);
                });
        },
        async beforeUpload(file) {
            setaccept(ACCEPT_LIST.toString(','));
            let ERROR_MSG = [];
            const [msg1 /* msg2, msg3 */] = intl
                .get('userCenter.uploadMaterialDesc')
                .split(',');

            const isInclude = ACCEPT_LIST.includes(file.type);
            if (!isInclude) ERROR_MSG.push(msg1);

            /*  if (!isLt) ERROR_MSG.push(msg2); */

            /*  if (isInclude) {
                 const IMAGE = new window.Image();
                 IMAGE.src = URL.createObjectURL(file);
                 try {
                     await new Promise(resolve => {
                         IMAGE.onload = () => {
                             resolve();
                         };
                     });
                 } finally {
                     const { width, height } = IMAGE;
                     if (width > 15000 || height > 15000) ERROR_MSG.push(msg3);
                 }
             } */

            ERROR_MSG = ERROR_MSG.map((str, idx) => (
                <p className="message-item" key={idx}>
                    {ERROR_MSG.length > 1 && '-'}
                    {str}
                </p>
            ));

            !!ERROR_MSG.length && message.error(ERROR_MSG);
            return !ERROR_MSG.length || Upload.LIST_IGNORE;
        },
        onDrop() {
            setaccept('');
        },
    };

    const normFile = e => {
        if (Array.isArray(e)) return e;
        return e?.fileList;
    };

    const [planVisible, setPlanVisible] = useState(false);
    // 关联
    const handleRelevance = evt => {
        evt.stopPropagation();
        setPlanVisible(true);
    };

    const [selectDrawing, setSelectDrawing] = useState([]);
    //  选择关联施工图回调
    const onSelectPlan = (keys, nodes) => {
        setSelectDrawing(nodes);
    };

    // 删除施工图
    const deleteDrawing = item => {
        setSelectDrawing(prev => {
            const next = prev.filter(e => {
                return e.key !== item.key;
            });
            return next;
        });
    };

    const [formRef] = Form.useForm();
    const [btnLoading, setBtnLoading] = useState(false);
    async function onFinish(fieldsValue) {
        const values = {
            ...fieldsValue,
            timeAt: fieldsValue.timeAt.format('YYYY-MM-DD'),
            timeEnd: fieldsValue.timeEnd.format('YYYY-MM-DD'),
            adjunct:
                fieldsValue.adjunct?.map(e => ({
                    name: e.name || e.response.fileName,
                    size: e.response.fileSize,
                    url: e.response.filePath,
                    fileType: e.response.fileType,
                })) ?? [],
            drawings: selectDrawing, // 施工图id
            targetPlanId,
            days: undefined,
        };
        setBtnLoading(true);
        try {
            const { msg } = await addPlan(values);
            message.success(msg);
            onSuccess();
            closeModal();
        } finally {
            setBtnLoading(false);
        }
    }

    const [dutyId, setDutyId] = useState('');
    const [joinId, setJoinId] = useState([]);

    function onValuesChange(obj) {
        const [[key, val]] = Object.entries(obj);
        switch (key) {
            case 'days':
            case 'timeAt':
            case 'isHoliday':
                calcTimes();
                break;
            case 'dutyId':
                setDutyId(val);
                break;
            case 'joinId':
                setJoinId(val || []);
                break;
            default:
                break;
        }
    }

    const [loading, setloading] = useState(false);

    async function calcTimes() {
        const startDate = formRef.getFieldValue('timeAt');
        const days = formRef.getFieldValue('days');
        if (!startDate || !days) return;
        const isHoliday = formRef.getFieldValue('isHoliday');
        let timeEnd;
        if (!!isHoliday) {
            setloading(true);
            await queryTimes({
                days,
                timeAt: startDate.format('YYYY-MM-DD'),
                isHoliday,
            })
                .then(({ data }) => {
                    timeEnd = data.timeEnd;
                })
                .finally(() => {
                    setloading(false);
                });
        } else {
            timeEnd = moment(startDate).add(days - 1, 'day');
        }
        formRef.setFieldsValue({ timeEnd: moment(timeEnd) });
    }

    const { Item } = Form;

    const getMembers = list => {
        return list.map(e => {
            return {
                value: e.userId,
                label: (
                    <p
                        className="member-select-item"
                        title={`${e.username} ${e.roleName}`}>
                        <span className="username">{e.username}</span>{' '}
                        <span className="role-tag">{e.roleName}</span>
                    </p>
                ),
            };
        });
    };
    const authorities = getMembers(
        members.filter(e => !joinId.includes(e.userId))
    );
    const JOIN_LIST = getMembers(members.filter(e => e.userId !== dutyId));

    const [templateTagList, setTemplateTagList] = useState([]);
    const [constructionProcess, setConstructionProcess] = useState('');
    const [processOptions, setProcessOptions] = useState([]);
    useEffect(() => {
        setProcessOptions(templateTagList);
    }, [templateTagList]);
    const onChangeProcess = value => {
        setConstructionProcess(value);
    };
    const queryTagList = async () => {
        try {
            const sendData = {
                projectId: pID,
            };
            const res = await getTemplateTagList(sendData);
            const option = res.data.map(item => {
                return { label: item.title, value: item.title };
            });
            setTemplateTagList(option);
        } catch (e) {}
    };
    const onSearchProcess = searchText => {
        setProcessOptions(
            templateTagList.filter(
                item => item.value.indexOf(searchText) !== -1
            )
        );
    };
    const cleanData = () => {
        setConstructionProcess('');
        setProcessOptions([]);
        // formRef.resetFields();
    };

    const parseNumber = num => {
        if (!num) return num;
        num = num.replace(/[^0-9]/g, '');
        if (num < 1) return 1;
        if (num > 365 * 3) return 365 * 3;
        return num;
    };
    return (
        <>
            <BaseModal
                title={intl.get('projectSpace.newPlan')}
                width="25.75rem"
                footer={
                    <Space>
                        <Button onClick={closeModal}>
                            {intl.get('base.cancel')}
                        </Button>
                        <Button
                            type="primary"
                            loading={btnLoading}
                            onClick={formRef.submit}>
                            {intl.get('base.confirm')}
                        </Button>
                    </Space>
                }
                wrapClassName={`${planVisible ? 'type--hidden' : ''}`}
                mask={!planVisible}
                visible={visible}
                onCancel={closeModal}>
                <div className="new-plan modal-content">
                    <Form
                        onValuesChange={onValuesChange}
                        form={formRef}
                        onFinish={onFinish}
                        labelCol={{ span: 6 }}
                        initialValues={{
                            timeAt: moment(),
                            timeEnd: moment(),
                            days: 1,
                        }}
                        className="basic-form">
                        <Item hidden name="projectId" initialValue={pID}></Item>
                        <Item
                            rules={[
                                {
                                    required: true,
                                },
                                {
                                    validator: async (rule, value) => {
                                        if (!value) return;
                                        if (value.length < 31) {
                                            return Promise.resolve();
                                        }
                                        throw new Error(
                                            intl.get(
                                                'projectSpace.planNameLimit'
                                            )
                                        );
                                    },
                                },
                            ]}
                            name="planName"
                            label={intl.get('projectSpace.plan')}>
                            <Input
                                allowClear
                                placeholder={intl.get(
                                    'projectSpace.inputPlan'
                                )}></Input>
                        </Item>
                        <Item
                            rules={[
                                {
                                    validator: async (rule, value) => {
                                        if (!value) return;
                                        const reg = new RegExp(
                                            "[`~!@#$^&*()=|{}':;'\",\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]"
                                        );
                                        if (reg.test(value)) {
                                            return Promise.reject(
                                                new Error(
                                                    intl.get(
                                                        'projectSpace.folwWarn'
                                                    )
                                                )
                                            );
                                        }
                                        if (value.length > 10) {
                                            return Promise.reject(
                                                new Error(
                                                    intl.get(
                                                        'projectSpace.flowLimit'
                                                    )
                                                )
                                            );
                                        }
                                        return Promise.resolve();
                                    },
                                },
                            ]}
                            name="tagName"
                            label={intl.get(
                                'projectSpace.constructionProcess'
                            )}>
                            <AutoComplete
                                allowClear
                                options={processOptions}
                                onChange={onChangeProcess}
                                onSearch={onSearchProcess}
                                value={constructionProcess}
                                placeholder={intl.get('projectSpace.inputFlow')}
                            />
                        </Item>
                        <Item
                            name="days"
                            label={intl.get('projectSpace.planLimit')}
                            normalize={parseNumber}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}>
                            <Input suffix="天" className="unit-input"></Input>
                        </Item>
                        <Item
                            valuePropName="checked"
                            name="isHoliday"
                            normalize={value => (value ? 1 : 0)}
                            wrapperCol={{ offset: 6 }}>
                            <Checkbox>
                                {intl.get('projectSpace.deduct')}
                            </Checkbox>
                        </Item>
                        <Item
                            label={intl.get('projectSpace.planStart')}
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                            name="timeAt">
                            <DatePicker
                                suffixIcon={
                                    <i className="icon-calendar filled" />
                                }
                            />
                        </Item>

                        <Item
                            label={intl.get('projectSpace.planEnd')}
                            name="timeEnd"
                            className="check-item-bro">
                            <DatePicker
                                bordered={false}
                                suffixIcon={
                                    loading ? <LoadingOutlined /> : null
                                }
                                disabled
                            />
                        </Item>
                        <Item label={intl.get('team.principal')} name="dutyId">
                            <Select
                                allowClear
                                placeholder={intl.get('team.selectOne')}
                                options={authorities}
                                suffixIcon={
                                    <i className="icon-caret-down filled" />
                                }></Select>
                        </Item>
                        <Item
                            label={intl.get('team.participant')}
                            name="joinId">
                            <Select
                                mode="multiple"
                                allowClear
                                placeholder={intl.get(
                                    'baseComponents.baseInfo.pleaseSelect'
                                )}
                                options={JOIN_LIST}
                                suffixIcon={
                                    <i className="icon-caret-down filled" />
                                }></Select>
                        </Item>
                        <Item
                            label={intl.get('templateSettings.accessory')}
                            className="accessory">
                            <Item
                                noStyle
                                name="adjunct"
                                valuePropName="fileList"
                                getValueFromEvent={normFile}>
                                <Upload style={{ width: '100%' }} {...ATTRS}>
                                    <div className="upload-content">
                                        <Tooltip
                                            title={intl.get(
                                                'projectSpace.uploadLimit'
                                            )}>
                                            <a className="native-link">
                                                {intl.get('base.accessoryAdd')}
                                            </a>
                                        </Tooltip>
                                        &nbsp;/&nbsp;
                                        <a
                                            className="native-link"
                                            onClick={handleRelevance}>
                                            {intl.get(
                                                'projectSpace.drawingsAssociate'
                                            )}
                                        </a>
                                    </div>
                                </Upload>
                            </Item>

                            {selectDrawing.map(e => (
                                <section key={e.key} className="file-list">
                                    <i className="icon-Linkpdf outlined pdf-icon"></i>
                                    <div
                                        className="file-list-content"
                                        title={e.name}>
                                        {e.name}
                                    </div>
                                    <DeleteOutlined
                                        onClick={() => deleteDrawing(e)}
                                        className="delete-icon"
                                    />
                                </section>
                            ))}
                        </Item>
                        <Item label={intl.get('base.remark')} name="remark">
                            <Input.TextArea
                                allowClear
                                autoSize={{
                                    minRows: 3,
                                    maxRows: 4,
                                }}></Input.TextArea>
                        </Item>
                        {isNeed && (
                            <Item
                                label={intl.get('projectSpace.ownerConfirm')}
                                name="isOwnerAffirm"
                                initialValue={1}>
                                <Radio.Group>
                                    <Radio value={0}>
                                        {intl.get('projectSpace.notNeed')}
                                    </Radio>
                                    <Radio value={1}>
                                        {intl.get('projectSpace.need')}
                                    </Radio>
                                </Radio.Group>
                            </Item>
                        )}
                    </Form>
                </div>
            </BaseModal>

            <PlanTreeModal
                visible={planVisible}
                setVisible={setPlanVisible}
                onSelected={onSelectPlan}
                projectId={pID}
                initValues={selectDrawing}
            />

            <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                    preview={{
                        visible: isPreview,
                        onVisibleChange: setIsPreview,
                    }}>
                    <Image src={currentPreview}></Image>;
                </Image.PreviewGroup>
            </div>
        </>
    );
}

export default memo(NewPlan);
